import Vue from 'vue'
import Vuex from 'vuex'
import messages from './messages.js'
import user from './user.js'
import rooms from './rooms.js'
import utils from './utils.js'
import {auth} from "../firebase"

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
    checkAuth( {commit}){
      auth.onAuthStateChanged(function (user){
        if (user){
          commit("user/setUser",user);
        }else{
          commit("user/setUser",null);
        }
      })
    }
  },
  modules: {
    messages,
    rooms,
    user,
    utils
  }
})

export default store;
//initial Load
store.dispatch("checkAuth");